import React, { useState, useEffect } from 'react';
import { AppBar, UserMenu, MenuItemLink, usePermissions, useDataProvider } from 'react-admin';
import { Tooltip } from '@mui/material';
import SlideOutTray from '../slideout-tray/slideout.tray';

import TenantSelectorToolbar from '../../modules/tenant/tenant.selector';
import BrandSelectorToolbar from '../../modules/brand/brand.selector';
import ImageIcon from '../image/image.icon';
import AppExtensionProviderRegistry, { AppExtension, AppExtensionProvider } from '../../framework/app/app.extension.provider';
import { getConfig } from '../../framework/config/app.config';
import VersionInfo from '../version/VersionInfo';

export interface CustomAppBarProps {    
  appExtensionProvider: AppExtensionProvider
}

const CustomAppBar = (props) => {  
  const [isTrayOpen, setIsTrayOpen] = useState(false);
  const [tenantName, setTenantName] = useState<string | null>(null);
  const { isLoading, permissions } = usePermissions();
  const dataProvider = useDataProvider();
  const appExtension:AppExtension = AppExtensionProviderRegistry.getDefaultProvider()?.getAppExtension();

  // JK TODO remove tenant and brand selector state dependencies, then remove thos selectors from the code we are not using that UI approach 
 const tenantAdmin = true;
 const banner = appExtension?.getAppImage() || './banner.png';
  
  // Fetch tenant data to get tenant name
  useEffect(() => {
    const fetchTenantName = async () => {
      try {
        const { data } = await dataProvider.getList('tenant', {
          filter: {},
          pagination: { page: 1, perPage: 1 },
          sort: { field: 'name', order: 'ASC' }
        });
        
        if (data && data.length > 0) {
          setTenantName(data[0].name);
        }
      } catch (error) {
        console.error('Failed to fetch tenant name:', error);
        // Fallback to environment name if tenant fetch fails
        setTenantName(sessionStorage.getItem('selectedEnv'));
      }
    };

    fetchTenantName();
  }, []); // Empty array - only run once on mount (dataProvider is stable from react-admin)
  
  // Listen for programmatic requests to open AI chat - DISABLED
  // useEffect(() => {
  //   const handleOpenAIChat = (event: CustomEvent) => {
  //     console.log('🔔 [CustomAppBar] Received openAIChat event:', event.detail);
  //     setIsTrayOpen(true);
  //   };
  //   
  //   window.addEventListener('openAIChat', handleOpenAIChat as EventListener);
  //   
  //   return () => {
  //     window.removeEventListener('openAIChat', handleOpenAIChat as EventListener);
  //   };
  // }, []);
  
  // Disabled - AI Insights coming soon
  // const toggleTray = () => {
  //   setIsTrayOpen(!isTrayOpen);
  // };

  // Use tenant name if available, otherwise fallback to environment name
  const displayName = tenantName || sessionStorage.getItem('selectedEnv') || '';

  return (
    <>
      <AppBar {...props}>
        <img src={banner} alt="Logo" style={{ marginRight: '1rem',  height: 35,  objectFit: 'contain'}} />
        <div style={{ marginLeft: '1rem', marginRight: '1rem', fontSize: '16px', color: 'white' }}>
          {displayName}
        </div>
        {tenantAdmin ? (<TenantSelectorToolbar />) : null}
        {tenantAdmin ? (<BrandSelectorToolbar />) : null}
        <VersionInfo />
        <Tooltip title="AI Insights — Coming Soon" arrow>
          <button 
            disabled
            style={{ 
              marginLeft: 'auto', 
              marginRight: '1rem', 
              background: 'none', 
              border: 'none',
              cursor: 'not-allowed',
              opacity: 0.6,
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
              }
            }}
            aria-label="AI Insights — Coming Soon"
          >
            <ImageIcon src="./icons/ai-icon.png" />
          </button>
        </Tooltip>
      </AppBar>
      <SlideOutTray isOpen={isTrayOpen} onClose={() => setIsTrayOpen(false)} />
    </>
  );
};

export default CustomAppBar;